import React, {useContext} from "react";
import {motion} from "framer-motion";
import "./Skills.scss";
import {skillsSection} from "../../portfolio";
import StyleContext from "../../contexts/StyleContext";
import {fadeUp, staggerCards, cardItem, vp} from "../../utils/animations";
import {
  RiBrainLine,
  RiBarChart2Line,
  RiServerLine,
  RiToolsLine
} from "react-icons/ri";

const CATEGORY_ICONS = {
  "LLM Systems": RiBrainLine,
  Observability: RiBarChart2Line,
  "Backend & Infra": RiServerLine,
  Tooling: RiToolsLine
};

export default function Skills() {
  const {isDark} = useContext(StyleContext);
  if (!skillsSection.display) return null;

  return (
    <motion.section
      className={`caps ${isDark ? "dark" : ""}`}
      id="skills"
      initial="hidden"
      whileInView="show"
      viewport={vp}
      variants={fadeUp}
    >
      <div className="caps__inner">
        <motion.div className="caps__header" variants={fadeUp}>
          <span className="section-label">Capabilities</span>
          <h2 className="caps__title">{skillsSection.title}</h2>
          <p className="caps__desc">
            The systems I design, the stack I work in, and the tools I reach for
            first.
          </p>
        </motion.div>

        <motion.div
          className="caps__grid"
          variants={staggerCards}
          initial="hidden"
          whileInView="show"
          viewport={{once: true, amount: 0.05}}
        >
          {skillsSection.skillGroups.map((g, i) => {
            const Icon = CATEGORY_ICONS[g.category] || RiToolsLine;
            return (
              <motion.div key={i} className="cap-group" variants={cardItem}>
                <div className="cap-group__icon" aria-hidden="true">
                  <Icon size={18} />
                </div>
                <h3 className="cap-group__cat">{g.category}</h3>
                <ul className="cap-group__list">
                  {g.items.map((item, j) => (
                    <li key={j} className="cap-group__item">
                      <span className="cap-group__dot" aria-hidden="true" />
                      {item}
                    </li>
                  ))}
                </ul>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </motion.section>
  );
}
